import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrap" }
const _hoisted_2 = {
  key: 0,
  class: "answer-field"
}
const _hoisted_3 = {
  ref: "hidden",
  class: "hidden-input"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, { name: "answer-field" }, {
      default: _withCtx(() => [
        (_ctx.isShow)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.whatKindOfInputShow), {
                autofocus: !_ctx.isPhoneSize,
                onInputValue: _ctx.sendMessage
              }, null, 40, ["autofocus", "onInputValue"]))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createElementVNode("input", _hoisted_3, null, 512)
  ]))
}